import type { ComponentProps } from 'react';

export const HomeIcon = (props:ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
    <path
      d="M12 40.571C12 34.1634 12 30.9596 13.4538 28.3037C14.9075 25.6478 17.5634 23.9994 22.8753 20.7028L28.4753 17.2272C34.0903 13.7424 36.8978 12 40 12C43.1022 12 45.9097 13.7424 51.5247 17.2272L57.1247 20.7027C62.4366 23.9994 65.0925 25.6478 66.5462 28.3037C68 30.9596 68 34.1634 68 40.571V44.8299C68 55.7524 68 61.2136 64.7196 64.6068C61.4392 68 56.1595 68 45.6 68H34.4C23.8405 68 18.5608 68 15.2804 64.6068C12 61.2136 12 55.7524 12 44.8299V40.571Z"
      stroke="currentColor" strokeWidth="6" />
    <path d="M40 48L40 57" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
  </svg>
)